import axios from 'axios';

/**
 * Notices when the backend says a gallery's sharing has been switched off.
 *
 * The interceptor is registered here, at module scope, rather than from a
 * useEffect in App: axios freezes a request's interceptor chain at the moment
 * the call is made, and a page's own effect (which fires its first request)
 * runs *before* its parent's effect. An interceptor added from App would
 * therefore miss the very first gallery load — the one that matters. Importing
 * this module from App installs it before anything renders.
 */
let blocked = false;
const listeners = new Set();

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      !blocked &&
      error?.response?.status === 403 &&
      error.response?.data?.sharing_disabled
    ) {
      blocked = true;
      listeners.forEach((notify) => notify(true));
    }
    return Promise.reject(error);
  }
);

export const isSharingBlocked = () => blocked;

export function subscribeSharingBlocked(notify) {
  listeners.add(notify);
  return () => listeners.delete(notify);
}
